// #region Type
export const ACTION_TYPE = {
  CALL_API_INIT_MAIL_MAGAZINE_LIST: 'CALL_API_INIT_MAIL_MAGAZINE_LIST',
  INIT_MAIL_MAGAZINE_LIST_SUCCESS: 'INIT_MAIL_MAGAZINE_LIST_SUCCESS',
  CALL_API_MAIL_MAGAZINE_LIST: 'CALL_API_MAIL_MAGAZINE_LIST',
  CALL_API_MAIL_MAGAZINE_LIST_SUCCESS: 'CALL_API_MAIL_MAGAZINE_LIST_SUCCESS',
  CALL_API_DELETE_MAIL_MAGAZINE: 'CALL_API_DELETE_MAIL_MAGAZINE',
  CALL_API_DELETE_MAIL_MAGAZINE_SUCCESS: 'CALL_API_DELETE_MAIL_MAGAZINE_SUCCESS',
  SET_SEARCH_MAIL_MAGAZINES: 'SET_SEARCH_MAIL_MAGAZINES',
};
// #endregion

// #region Type
export const actCallInitMailMagazineList = () => ({
  type: ACTION_TYPE.CALL_API_INIT_MAIL_MAGAZINE_LIST,
});

export const actInitMailMagazineListSuccess = (selects) => ({
  type: ACTION_TYPE.INIT_MAIL_MAGAZINE_LIST_SUCCESS,
  selects,
});

export const actCallApiMailMagazineList = (searchCondition) => ({
  type: ACTION_TYPE.CALL_API_MAIL_MAGAZINE_LIST,
  searchCondition,
});

export const actCallApiMailMagazineListSuccess = (datas) => ({
  type: ACTION_TYPE.CALL_API_MAIL_MAGAZINE_LIST_SUCCESS,
  datas,
});

export const actCallApiDeleteMailMagazine = (ids) => ({
  type: ACTION_TYPE.CALL_API_DELETE_MAIL_MAGAZINE,
  ids,
});

export const actCallApiDeleteMailMagazineSuccess = () => ({
  type: ACTION_TYPE.CALL_API_DELETE_MAIL_MAGAZINE_SUCCESS,
});

export const actSetSearchCondition = (searchCondition) => ({
  type: ACTION_TYPE.SET_SEARCH_MAIL_MAGAZINES,
  searchCondition,
});
// #endregion
